import _ from 'lodash';
import {TotalResultHandler} from '../../resources/config-schema';
import {IBaselineSubmissionProps, IFinaleSubmissionProps} from '../resources/Submission';
import makeAverage from '@/utils/makeAverage';

const transform = [
    {
        name: 'Avg turnover baseline',
        filterKey: 'baselineValue',
    },
    {
        name: 'Avg turnover final',
        filterKey: 'finalValue',
    },
];

/**
 * == baseline
 * question5_turnover_value
 * 
 * == final
 * question79_turnover_value
 * 
 * @param baselineSubmission 
 * @param finalSubmission 
 * @returns
 */
export const averageIncreasedChartCalculation: TotalResultHandler<IBaselineSubmissionProps, IFinaleSubmissionProps> =
    (baselineSubmission, finalSubmission) => {
        const baselineMap = _.keyBy(baselineSubmission, 'uoa_id');
        const finalMap = _.keyBy(finalSubmission, 'uoa_id');

        let result = _.mergeWith(baselineMap, finalMap, (base, fin) => ({
            baselineValue: base ? base.question5_turnover_value : null,
            baselineCur: base ? base.question5_turnover_currency : null,
            finalValue: fin ? fin.question79_turnover_value : null,
            finalCur: fin ? fin.question79_turnover_currency : null
        }));

        result = _.pickBy(result, ({ baselineValue, baselineCur, finalValue, finalCur}: any) =>
            finalValue != null &&
            baselineValue != null &&
            baselineCur === finalCur &&
            finalValue > baselineValue
        )
    
        const data = transform.map((el) => (
            makeAverage(_.map(result, el.filterKey), 2)
        ));

        if (data.length > 1 && data[1] > 0) {
            return (data[0] / data[1] * 100).toFixed(2);
        }

        return '0';
    }